import { BudgetPhases } from 'business/constants';
import { createContext } from 'react';
import { StatusesSettingsT } from 'routes/BudgetModule/config/types';

export const StatusSettingsContext: React.Context<StatusesSettingsT> =
    createContext<StatusesSettingsT>({
        [BudgetPhases.ARBITRAGE]: {},
        [BudgetPhases.VOTE]: {},
        [BudgetPhases.CADRAGE]: {},
        [BudgetPhases.PROPOSITION_SERVICES]: {},
        [BudgetPhases.ARCHIVED]: {},
        [BudgetPhases.SUPPLEMENTARY_BUDGET]: {},
        [BudgetPhases.ARBITRAGE_DM]: {},
    });
